<template>
  <div>
    <vxe-grid
      auto-resize
      highlight-hover-row
      highlight-current-row
      :tree-config="treeConfig"
      border
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      @current-change="onCurrentChange"
      row-id="locationCode"
      size="small"
      ref="xTree"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <!-- <template v-slot:pager>
        <slot name="pager"></slot>
      </template> -->
      <template v-slot:categoryStatus="{ row }">
        <el-tag
          size="mini"
          :type="row.categoryStatus === 'Y' ? 'light' : 'warning'"
        >
          {{ row.categoryStatusName }}
        </el-tag>
      </template>
      <template v-slot:empty>
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.table_label_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import store from '../../store'
export default {
  mixins: [TableAutoHeight],
  props: {
    tableData: {
      type: Array,
      default: () => []
    },
    tablePage: {
      type: Object,
      default: () => {}
    },
    loading: {
      default: false
    }
  },
  components: {},
  data() {
    return {
      treeConfig: {
        children: 'childs',
        line: true
      },
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form'
        },
        refresh: {
          query: () => this.$emit('reload')
        }
      },
      tableColumns: [
        {
          title: this.$l('table_label_location_no') || '库位编号',
          field: 'locationNo',
          minWidth: '120px',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
          treeNode: true
        },
        {
          title: this.$l('table_label_location_description') || '库位描述',
          field: 'locationDescription',
          minWidth: '120px',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis'
        }
      ]
    }
  },
  methods: {
    onCurrentChange({ row }) {
      store.commit('setSelected', row)
    }
  }
}
</script>
<style lang="scss" scoped>
.tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}
</style>
